// src/components/FeatureRoute.jsx
import { Navigate } from "react-router-dom";
import useSubscriptionFeatureStore from "../store/useSubscriptionFeatureStore";

/**
 * Wraps a route element — redirects to /error if the subscription
 * doesn't include the required feature.
 *
 * Usage:
 *   <FeatureRoute feature="route_management"><RouteList /></FeatureRoute>
 */
const FeatureRoute = ({ feature, children, redirectTo = "/error" }) => {
  const featureCodes = useSubscriptionFeatureStore((s) => s.featureCodes);
  const featureCodesLoaded = useSubscriptionFeatureStore((s) => s.featureCodesLoaded);

  // Still loading — render nothing to avoid a flicker redirect
  if (!featureCodesLoaded) return null;

  return featureCodes.includes(feature)
    ? children
    : <Navigate to={redirectTo} replace />;
};

export default FeatureRoute;